import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  usageService,
  type UsageIncrementRequest,
  type ServiceName,
} from '@/services/usage'

// Get current usage
export const useUsage = (
  organizationId: string,
  serviceName?: ServiceName
) => {
  return useQuery({
    queryKey: ['usage', organizationId, serviceName],
    queryFn: () => usageService.getCurrentUsage(organizationId, serviceName),
    enabled: !!organizationId,
    refetchInterval: 30000, // Refetch every 30 seconds
  })
}

// Get usage history
export const useUsageHistory = (
  organizationId: string,
  params?: {
    service_name?: ServiceName
    limit?: number
    offset?: number
  }
) => {
  return useQuery({
    queryKey: ['usage-history', organizationId, params],
    queryFn: () => usageService.getUsageHistory(organizationId, params),
    enabled: !!organizationId,
  })
}

// Increment usage (internal use)
export const useIncrementUsage = (organizationId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: UsageIncrementRequest) =>
      usageService.incrementUsage(organizationId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['usage', organizationId, variables.service_name],
      })
      queryClient.invalidateQueries({
        queryKey: ['usage-history', organizationId],
      })
      queryClient.invalidateQueries({ queryKey: ['dashboard'] })
    },
  })
}

